import { render, staticRenderFns } from "./MinusCircleIcon.vue?vue&type=template&id=d63ece94&scoped=true"
import script from "./MinusCircleIcon.vue?vue&type=script&lang=js"
export * from "./MinusCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63ece94",
  null
  
)

export default component.exports